(function () {
  if (window.__obCuInit) return;
  window.__obCuInit = true;

  var FAILSAFE_MS = 10000;

  /* ---------- Carousel ---------- */

  function getStep(track) {
    var card = track.querySelector('[data-ob-cu-card]');
    if (!card) return track.clientWidth || 1;
    var styles = getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return card.getBoundingClientRect().width + gap || 1;
  }

  function update(root) {
    if (!root) return;
    var track = root.querySelector('[data-ob-cu-track]');
    if (!track || !track.clientWidth) return;

    var cards = track.querySelectorAll('[data-ob-cu-card]');
    var max = Math.max(0, track.scrollWidth - track.clientWidth);
    var x = track.scrollLeft;
    var step = getStep(track);
    var scrollable = max > 2 && cards.length > 1;

    root.classList.toggle('is-static', !scrollable);

    var prev = root.querySelector('[data-ob-cu-prev]');
    var next = root.querySelector('[data-ob-cu-next]');
    if (prev) prev.disabled = x <= 2;
    if (next) next.disabled = x >= max - 2;

    var dots = root.querySelectorAll('[data-ob-cu-dot]');
    if (!dots.length) return;

    var positions = scrollable ? Math.min(cards.length, Math.ceil((max - 2) / step) + 1) : 1;
    var idx = x >= max - 2 ? positions - 1 : Math.min(positions - 1, Math.round(x / step));

    for (var i = 0; i < dots.length; i++) {
      var dot = dots[i];
      var active = i === idx;
      dot.hidden = i >= positions;
      dot.classList.toggle('is-active', active);
      if (active) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    }
  }

  function updateAll() {
    document.querySelectorAll('[data-ob-cu]').forEach(update);
  }

  var ro = 'ResizeObserver' in window
    ? new ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
          update(entry.target.closest('[data-ob-cu]'));
        });
      })
    : null;

  function watchTracks() {
    document.querySelectorAll('[data-ob-cu-track]').forEach(function (track) {
      if (track.__obCuWatched) return;
      track.__obCuWatched = true;
      if (ro) ro.observe(track);
    });
  }

  var rafPending = false;
  function scheduleRefresh() {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(function () {
      rafPending = false;
      watchTracks();
      updateAll();
    });
  }

  // Scroll doesn't bubble, so listen in the capture phase
  document.addEventListener(
    'scroll',
    function (e) {
      var t = e.target;
      if (!t || t.nodeType !== 1 || !t.matches('[data-ob-cu-track]')) return;
      if (t.__obCuRaf) return;
      t.__obCuRaf = requestAnimationFrame(function () {
        t.__obCuRaf = null;
        update(t.closest('[data-ob-cu]'));
      });
    },
    true
  );

  // Capture phase so drawer handlers can't swallow the click
  document.addEventListener(
    'click',
    function (e) {
      var el = e.target && e.target.closest
        ? e.target.closest('[data-ob-cu-prev], [data-ob-cu-next], [data-ob-cu-dot]')
        : null;
      if (!el) return;

      var root = el.closest('[data-ob-cu]');
      var track = root && root.querySelector('[data-ob-cu-track]');
      if (!track) return;

      e.preventDefault();

      var step = getStep(track);
      var max = Math.max(0, track.scrollWidth - track.clientWidth);
      var target;

      if (el.hasAttribute('data-ob-cu-prev')) {
        target = Math.max(0, track.scrollLeft - step);
      } else if (el.hasAttribute('data-ob-cu-next')) {
        target = Math.min(max, track.scrollLeft + step);
      } else {
        var idx = parseInt(el.getAttribute('data-ob-cu-dot'), 10) || 0;
        target = Math.min(idx * step, max);
      }

      track.scrollTo({ left: target, behavior: 'smooth' });
    },
    true
  );

  // Catch cart re-renders and drawer open/close toggles
  function observeBody() {
    new MutationObserver(scheduleRefresh).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'open', 'hidden', 'aria-hidden']
    });
    scheduleRefresh();
  }

  window.addEventListener('resize', scheduleRefresh);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeBody);
  } else {
    observeBody();
  }

  /* ---------- Add to cart loading state ---------- */

  function setLoading(btn) {
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    btn.setAttribute('aria-disabled', 'true');
    var status = btn.querySelector('[data-ob-cu-atc-status]');
    if (status) status.textContent = 'Adding to cart';
    clearTimeout(btn.__obCuTimer);
    btn.__obCuTimer = setTimeout(function () {
      resetButton(btn);
    }, FAILSAFE_MS);
  }

  function resetButton(btn) {
    clearTimeout(btn.__obCuTimer);
    btn.classList.remove('is-loading');
    btn.removeAttribute('aria-busy');
    btn.removeAttribute('aria-disabled');
    var status = btn.querySelector('[data-ob-cu-atc-status]');
    if (status) status.textContent = '';
  }

  function resetAll() {
    document.querySelectorAll('[data-ob-cu-atc].is-loading').forEach(resetButton);
  }

  // Capture phase so this runs before the theme's add-to-cart handler
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.querySelector) return;
      var btn = form.querySelector('[data-ob-cu-atc]');
      if (!btn) return;

      if (btn.classList.contains('is-loading')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }

      setLoading(btn);
    },
    true
  );

  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:error'].forEach(function (evt) {
    document.addEventListener(evt, resetAll);
  });

  window.addEventListener('pageshow', resetAll);
})();
